import * as React from "react";

import { PropertyFilteredReviews } from "@shared-ui/lodging-reviews";

import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";

import { UitkFullscreenDialog, UitkDialogContent } from "uitk-react-dialog";
import { UitkToolbar, UitkToolbarProps, ToolbarType } from "uitk-react-toolbar";

const WrappedPropertyFilteredReviews = PropertyBexApiWrapper(PropertyFilteredReviews);

export const PropertyFilteredReviewsDialog: React.FC<ComponentProps & { onClose: () => void }> = ({
  context,
  onClose,
}) => {
  // TODO: localize the strings below
  const toolbarProps: UitkToolbarProps = {
    type: ToolbarType.CLOSE,
    action: onClose,
    header: "Guest reviews",
    iconLabel: "Cancel, go back to hotel details",
  };

  return (
    <UitkFullscreenDialog strictFullscreen={true} wideContent={true}>
      <UitkToolbar {...toolbarProps} />
      <UitkDialogContent>
        <WrappedPropertyFilteredReviews context={context} />
      </UitkDialogContent>
    </UitkFullscreenDialog>
  );
};
